export default "__VITE_ASSET__BbMBKgnI__"